import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.claim}claimGroups`;

export interface GetClaimGroupByIdQueryArgs {
  claimGroupId: string;
}

export const getClaimGroupByIdRequest = ({
  claimGroupId,
}: GetClaimGroupByIdQueryArgs): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${claimGroupId}`,
  config: { method: SUPPORTED_METHODS.GET },
});

export const getClaimGroupByIdQuery = async (
  args: GetClaimGroupByIdQueryArgs,
): Promise<BackResponse<Record<string, unknown>> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<Record<string, unknown>>>(
      getClaimGroupByIdRequest(args),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
